<template>
  <div class="flex justify-start pb-5">
    <a href="mailto:info@animauxdelasecondechance.com?subject=Faire un Don !&body=Bonjour, j'aimerais faire un don à votre organisme. Message :"
      target="_blank" title="Faire un don !" rel="noopener noreferrer"
      class="inline-flex items-center px-3 py-2 mt-5 text-sm sm:text-md md:text-lg font-medium text-center text-white bg-action rounded-lg hover:bg-navigation focus:ring-4 focus:outline-none focus:ring-white dark:primaire dark:hover:bg-navigation dark:focus:ring-white">
      Faire un don !
    </a>
  </div>
</template>